import{gql as e}from"graphql-tag";const o=e`
    subscription onMessageUpdate {
  onMessageUpdate {
    uuid
    content
    readAt
    conversationUuid
  }
}
    `;export{o as OnMessageUpdateDocument};
//# sourceMappingURL=onMessageUpdateSubscription.generated.es.js.map
